import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { pathToLeadingPage, toInit } from '../containers/App/RouterApp'
import { isDEV } from '../helpers'

import theme from '../theme'
import { useStyles } from './styled'

const HardRedirect = (props: { to: string }) => {
  useEffect(() => {
    window.location.href = props.to
  }, [props.to])
  return <></>
}

const Home = () => {
  const classes = useStyles(theme)

  if (!isDEV) {
    // There is no 'Home' page in the app.
    // When somebody gets here, we will redirect him to the leading page.
    return <HardRedirect to={pathToLeadingPage} />
  } else {
    return (
      <Grid className={classes.root}>
        <Grid
          item
          sm={12}
          xl={12}
          xs={12}
          container
          direction="row"
          className={classes.gridMainForm}
        >
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            {/*<Link
              to={{
                pathname: toInit({
                  type: 'ME',
                  webuserid: 'B9FEF0E487AD1011888AEB0703E67403',
                }),
              }}
            >*/}
            <a href="http://localhost:3000/#/init/ME/B9FEF0E487AB0703E67403">
              <Typography className={classes.text} variant="h5">
                {'Medical cost'}
              </Typography>
            </a>
            {/*</Link>*/}
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            {/*
            <Link
              to={{
                pathname: toInit({
                  type: 'ME',
                  webuserid: '1',
                }),
              }}
            >*/}
            <a href="http://localhost:3000/#/init/ME/1?__locale=e">
              <Typography className={classes.text} variant="h5">
                {'Medical cost - data 1'}
              </Typography>
            </a>
            {/*</Link>*/}
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            {/*<Link
              to={{
                pathname: toInit({
                  type: 'CA',
                }),
              }}
            >*/}
            <a href="http://localhost:3000/#/init/CA?__locale=en">
              <Typography className={classes.text} variant="h5">
                {'Trip Cancellation'}
              </Typography>
            </a>
            {/*</Link>*/}
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            <a href="http://localhost:3000/#/init/ME">
              <Typography className={classes.text} variant="h5">
                {'Test Link'}
              </Typography>
            </a>
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            <Link
              to={{
                pathname: toInit({
                  caseType: 'BA',
                }),
              }}
            >
              <Typography className={classes.text} variant="h5">
                {'Baggage Cancellation'}
              </Typography>
            </Link>
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            <Link
              to={{
                pathname: toInit({
                  caseType: 'PA',
                }),
              }}
            >
              <Typography className={classes.text} variant="h5">
                {'Personal Accident'}
              </Typography>
            </Link>
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            <Link
              to={{
                pathname: toInit({
                  caseType: 'PL',
                }),
              }}
            >
              <Typography className={classes.text} variant="h5">
                {'Liability'}
              </Typography>
            </Link>
          </Grid>
          <Grid
            item
            sm={4}
            xl={4}
            xs={3}
            container
            direction="row"
            className={classes.gridItem}
          >
            <Link
              to={{
                pathname: toInit({
                  caseType: 'TI',
                }),
              }}
            >
              <Typography className={classes.text} variant="h5">
                {'Ticket'}
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default Home
